export const RelationsTemplates = {
  'app/components/relations/partials/relations.hierarchy.html': require(
    './partials/relations.hierarchy.html'
  ).default
  // 'relations-hierarchy.html': require('./relations-hierarchy.html').default,
};
